import React from 'react';
export function TopBanner() {
  const segment = '🔥 +500 MADRES RECUPERARON A SU HIJO \u00A0\u00A0 🔒 PAGO 100% SEGURO \u00A0\u00A0 ⏰ OFERTA LIMITADA POR TIEMPO LIMITADO \u00A0\u00A0 ';
  const repeatedText = Array(8).fill(segment).join('');
  return <div className="fixed top-0 left-0 w-full bg-gradient-to-r from-maternal-amber to-maternal-gold text-white py-2 z-50 overflow-hidden shadow-md" data-id="element-208">
      <div className="whitespace-nowrap flex animate-marquee" data-id="element-209">
        <span className="text-xs md:text-sm font-bold tracking-wider" data-id="element-210">
          {repeatedText}
        </span>
        <span className="text-xs md:text-sm font-bold tracking-wider" data-id="element-211">
          {repeatedText}
        </span>
      </div>
    </div>;
}